<template>
  <div id="app">
    <!-- <Forest v-if="$route.query.style == 'myAppTree'"></Forest>
    <goal-progress></goal-progress> -->
    <my-progress v-if="$route.query.style == 'myAppTree'"></my-progress>
    <Tutorial v-if="!tutorialDone && this.$route.query.style == 'myAppTree'" class="fade"></Tutorial>
    <Rating v-if="!isThanks && this.$route.query.style" class="fade"></Rating>
    <NewsletterForm id="newsletterformmodal" 
    :lottie="'https://assets3.lottiefiles.com/packages/lf20_dyXaL5.json'"
    :text="newsletterlocale.subscribemail + newslettertrees + (newslettertrees == 1 ? newsletterlocale.tree : newsletterlocale.trees) + newsletterlocale.foryou"
    :placeholder="'yourmail@mail.com'"
    :type="'email'"
    @open-url="openUrl"></NewsletterForm>

    <Thanks class="fade" @share="shareScreenshot" id="thanksmodal" 
    :text="$locale.thanks.thankyou_saving_planet" 
    :modalId="'thanksmodal'" 
    :newTrees="newTrees"
    :lottie="'https://assets1.lottiefiles.com/temp/lf20_XOFhge.json'"></Thanks>

    <Thanks class="fade" @share="shareScreenshot" id="levelupmodal" 
    :text="$locale.thanks.congratulations_levelup" 
    :modalId="'levelupmodal'" 
    :newTrees="'1'"
    :lottie="'https://assets2.lottiefiles.com/datafiles/1QPWH9xjWBflXo1QBqsL0XszJILLRF2dMiZ7PBt3/Trophy-animation/trophy.json'"></Thanks>

    <vue-page-transition name="">  
      <keep-alive include="home">
        <router-view :key="$route.fullPath" @share="shareScreenshot"/>
      </keep-alive>
    </vue-page-transition>
    
  </div>
</template>
<script>
// import Forest from "./components/Forest.vue";
// import GoalProgress from "./components/GoalProgress.vue";
import MyProgress from "./components/MyProgress.vue";
import Tutorial from "./components/Tutorial.vue";
import Rating from "./components/Rating.vue";
import Thanks from "./components/Thanks.vue";
import NewsletterForm from "./components/NewsletterForm";

const $ = window.$;

export default {
  name: 'app',
    data() 
    {
    return {
      isThanks: false,
      newTrees: 0,
      tutorialDone: localStorage.tutorialDone,
      newsletterlocale: this.$locale.newsletter,
      newslettertrees: 1
    }
  },
  created(){
    /* eslint-disable no-console*/
    // localStorage.removeItem("mailNeverAgain")
    setTimeout(function(){console.log("RELOAD"); location.reload() }, 30 * 60 * 1000);
    window.catchPayload = (payload) => {
      /*  Notification Payload usage:
            {
              action: thanks
              newTrees: 2
            }
            or
            {
              action: review
            }
       */

      var paylobj = JSON.parse(payload);
        if('action' in paylobj){
            switch(paylobj.action){
                case 'thanks':
                    console.log("if payload.action === thanks")
                    this.newTrees = paylobj.newTrees;
                    console.log("New trees: "+paylobj.newTrees);
                    $('#thanksmodal').modal('show');
                    this.isThanks = true;
                    $('#reviewremindermodal').modal('hide');
                    //send kochava event: planted some trees
                    if(window.Android)
                      window.Android.SendEvent('Purchase', '{"currency": "Trees", "price": '+paylobj.newTrees+'}')
                    else if(window.webkit)
                      window.webkit.messageHandlers.iOS.postMessage({action: "sendEvent", param2: "Purchase", param3: paylobj.newTrees});
                    break;
                case 'redirect':
                    console.log("if payload.action === redirect");
                    //Vue.prototype.$payload = paylobj;
                    console.log("Path: "+paylobj.url);
                    //gestire redirect (es: redirect a ID di un componente spefico nella pagina Journey)
                    break;
                case 'review':
                    console.log("if payload.action === review")
                    if(!localStorage.neverAgainReview && !this.isThanks)
                      $('#reviewremindermodal').modal('show');
                    break;
                case 'mailnewsletter':
                    console.log("if payload.action === mailnewsletter")
                    if(!localStorage.mailNeverAgain && !this.isThanks)
                      $('#newsletterformmodal').modal('show');
                    break;
                default:
                    return false;
            }   
        }
    }

    window.showTutorial = () => {
      this.tutorialDone = false;
      // console.log("tutorialmodal = "+ document.getElementById('tutorialmodal'));
      $('#tutorialmodal').modal('show');
    }

    
  },
  mounted(){
  //  $('#newsletterformmodal').modal('show');
    // localStorage.removeItem('login_count');
    if (!localStorage.login_count){
      localStorage.login_count = 1;
      $('#tutorialmodal').modal('show');
    }else{
      localStorage.login_count++;
    }

    if(localStorage.login_count % 3 == 0 && !localStorage.neverAgainReview && !this.isThanks){
        $('#reviewremindermodal').modal('show');
    }
    // $('#tutorialmodal').modal('show');
  },
  methods: {
    shareScreenshot: function(text){
      if(window.Android){
        window.Android.ShareScreenshot(text);
        window.Android.SendEvent('Add to Wishlist', '{"name": "Share"}')
      }else if(window.webkit){
        window.webkit.messageHandlers.iOS.postMessage({action: "share", param2: text});
        window.webkit.messageHandlers.iOS.postMessage({action: "sendEvent", param2: "Add to Wishlist", param3: "Share"});
      }else
        console.log('share non supportato:\n'+text);
        
    },
    openUrl: function(url){
        if (window.Android){
          window.Android.goToPlayStore(url);
          window.Android.SendEvent('View', '{"name": "Open Url", "uri": "'+url+'"}')
        }else if (window.webkit){
          window.webkit.messageHandlers.iOS.postMessage({action: "openUrl", param2: url});
          window.webkit.messageHandlers.iOS.postMessage({action: "sendEvent", param2: "View", param3: "Open Url"});
        }else
          window.open(url);
    }
  },
  components: {
    // Forest,
    // GoalProgress,
    MyProgress,
    Tutorial,
    Rating,
    Thanks,
    NewsletterForm
  }
}
</script>

